export const hematology = [
  { id: '375', description: 'IDEXX CBC™' },
  { id: '3900', description: 'CBC Blood Film Evaluation' },
  { id: '300', description: 'IDEXX CBC-Select™' },
  { id: '3099', description: 'Platelet Count, Manual (if Indicated)' },
  { id: '56', description: 'Coagulation Panel 1—PLT, PT, PTT' },
];
